import React from "react"
import PropTypes from "prop-types"
import { ArrowLeft, ArrowSidemenu, Home } from "@bw/icons"
import { Link } from "gatsby"
import * as css from "./Breadcrumbs.module.css"

const Breadcrumbs = ({ breadcrumbs }) => {
  return (
    <div className={`${css.breadcrumbs} breadcrumbs`}>
      {breadcrumbs.map((item, i) => {
        if (item.to === "/") {
          // homepage
          return (
            <Link
              className={css.breadcrumbs__item}
              key={i}
              to={item.to}
              title={item.title}
            >
              {<Home className={css.breadcrumbs__home} />}
            </Link>
          )
        }

        if (i === breadcrumbs.length - 1) {
          // last item
          return (
            <span className={css.breadcrumbs__item} key={i}>
              <ArrowSidemenu
                fillColor="#fff"
                className={css.breadcrumbs__seperator}
              />
              {item.title}
            </span>
          )
        }

        return (
          <Link className={css.breadcrumbs__item} key={i} to={item.to}>
            {i === breadcrumbs.length - 2 && (
              <ArrowLeft fillColor="#fff" className={css.breadcrumbs__back} />
            )}
            <ArrowSidemenu
              fillColor="#fff"
              className={css.breadcrumbs__seperator}
            />
            {item.title}
          </Link>
        )
      })}
    </div>
  )
}

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      to: PropTypes.string,
    })
  ),
}

export { Breadcrumbs }
